export const SETTLEMENT_HELP_CARD = 'settlement-help-card';
export const SETTLEMENT_HELP_MODAL = 'settlement-help-modal';
export const HOLIDAY_LIST_MODAL = 'holiday-list-modal';
export const LAST_SETTLEMENT_CARD = 'last-settlement-card';
export const MONTH_FILTER_WITH_ARROW_ICONS = 'month-filter-with-arrow-icons';
export const SETTLEMENT_TABLE_HEADER = 'settlement-table-header';
export const SETTLEMENT_TABLE_FOOTER = 'settlement-table-footer';
export const GST_INVOICE_BUTTON = 'gst-invoice-button';
export const GST_INVOICE_MODAL_CONTAINER = 'gst-invoice-modal-container';
export const MONTHLY_SETTLEMENT_BUTTON = 'monthly-settlement-button';
export const NEXT_BUTTON = 'next-button';
export const PREVIOUS_BUTTON = 'previous-button';
export const SETTLEMENT_DETAILS_DRAWER = 'settlement-details-drawer';
export const SETTLEMENT_STATUS_CARD = 'settlement-status-card';
export const AMOUNT_BREAKUP_CARD = 'amount-breakup-card';
export const BANK_DETAILS = 'bank-details';
export const UTR_DETAILS = 'utr-details';
export const SETTLEMENT_TYPE = 'settlement-type';
export const SETTLEMENT_AMOUNT = 'settlement-amount';
export const SETTLEMENT_DOWNLOAD_CARD = 'settlement-download-card';
export const HOLIDAY_LIST = 'holiday-list';
export const HELP_MODAL = 'help-modal';
export const HELP_MODAL_DONE_BUTTON = 'help-modal-done-button';
export const HELP_MODAL_BODY_HEADING = 'help-modal-body-heading';
export const HELP_MODAL_BODY_CONTENT = 'help-modal-body-content';
export const HELP_MODAL_PROCESSING_TITLE = 'help-modal-processing-title';
export const HELP_MODAL_PROCESSING_BODY = 'help-modal-processing-body';
export const BANK_HOLIDAY_BODY_CONTENT = 'bank-holiday-body-content';
export const GST_INVOICES_MODAL = 'gst-invoices-modal';
export const GST_INVOICE_DOWNLOAD = 'gst-invoice-download';
export const SETTLEMENT_DATA_TABLE = 'settlement-data-table';
export const MONTH_FILTER_LEFT_ARROW_ICON = 'month-filter-left-arrow-icon';
export const MONTH_FILTER_RIGHT_ARROW_ICON = 'month-filter-right-arrow-icon';
export const MONTH_FILTER_SELECTED_MONTH = 'month-filter-selected-month';
export const REPORT_TEMPLATE_CARD = 'report-template-card';
export const REPORT_TEMPLATES = 'report-templates';
export const REPORT_TEMPLATE_NOTE = 'report-templates-note';
export const REPORT_TEMPLATE_INFO = 'report-templates-info';
export const SETTLEMENT_UTR = 'settlement-utr';
export const COLUMN_DESCRIPTION_DOWNLOAD = 'column-description-download';
export const MORE_COLUMN_POPOVER = 'more-column-popover';
export const TEMPLATE_APPLY_BUTTON = 'template-apply-button';
export const TEMPLATE_CANCEL_BUTTON = 'template-cancel-button';
export const GENERATE_REPORT_BUTTON = 'generate-report-button';
export const DOWNLOAD_REPORT_BUTTON = 'download-report-button';
export const SETTLEMENT_NEED_HELP_BUTTON = 'need-help-button';
export const EMPTY_SETTLEMENT_TABLE = 'empty-settlement-table';
export const VIEW_BANK_HOLIDAY = 'view-bank-holiday';
export const CHECK_ICON = 'check-icon';
export const TIMER_ICON = 'timer-icon';
export const EXCLAMATION_ICON = 'exclamation-icon';
export const COPY_ICON = 'copy-icon';
